import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import TableComponent from "../../components/TableComponent";
import UserRow from "../../components/UserRow";

import { changeUserInvoice, getUsers } from "../../api/user.deprecated";

const UsersTable = ({ history }) => {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);

  const [refresh, setRefresh] = useState(1);

  async function onInvoiceChange(id, newInvoiceStatus) {
    await changeUserInvoice(id, newInvoiceStatus);
    setRefresh(refresh * -1);
  }

  function showCertificates(id) {
    history.push(`/user/${id}/certificates`);
  }

  useEffect(() => {
    (async () => {
      const users = await getUsers();
      setUsers(users);
    })();
  }, [refresh]);

  return (
    <div className="table-wrapper">
      <Typography
        variant="h4"
        className="t-none"
        sx={{
          fontSize: "small",
        }}
      >
        {t("users")}
      </Typography>
      <TableComponent
        header={[
          { title: t("id"), sort: "id", style: { width: "5px", paddingRight: 0 } },
          { title: t("fullname"), sort: "fullname" },
          { title: t("email"), sort: "email" },
          { title: t("users_table.companies_and_positions") },
          {
            title: t("country"),
            sort: "country",
            style: { width: "5px", paddingRight: 0 },
          },
          { title: t("status"), sort: "status" },
          { title: t("users_table.pay_with_invoice"), sort: "invoice" },
          { title: t("certificates"), style: { width: "120px" } },
        ]}
        renderChildren={(user) => (
          <UserRow key={user.id} user={user} onInvoiceChange={onInvoiceChange} onShowCertificates={showCertificates} />
        )}
        items={users}
        search={["fullname", "id", "email", "username", "name"]}
        pagination
        users={users}
      />
    </div>
  );
};

export default UsersTable;
